/*
Diese Datei nicht importieren, sie wird nur verwendet um die environment.ts im Build-Prozess zu ersetzen.
 */
export const environment = {
    production: true,
    neoskopBrokerUrl: 'https://www.vhv.de/api/v2/brokercontact/',
    logoUrl: 'https://www.vhv.de/cyber',
    dankeSeiteUrl: 'https://www.vhv.de/firmen'
};
